import styled from "styled-components";
import {SectionWrapper} from "shared/Styles/Wrappers";
import {Paragraph} from "components/Typography";

export const Container = styled.div`
    padding: 124px 0;
    background-color: #fff;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_big}) {
        padding: 106px 0;
    }
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        padding: 98px 0;
    } 
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding: 60px 0;
    }
    
`;

export const Wrapper = styled(SectionWrapper)`
    display: flex;
    flex-wrap: wrap;
`;

export const Column = styled.div`
    width: 50%;

    &:nth-child(2) {
        display: flex;
        justify-content: flex-end;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet_big}) {
        &:nth-child(1) {
            width: 65%;
        }

        &:nth-child(2) {
            width: 35%;
            justify-content: center;
        }
    }
    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        width: 100% !important;
    }
`;

export const Title = styled.h3`
    font-size: 4rem;
    font-weight: 800;
    color: #000;
    margin-bottom: 48px;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        font-size: 3rem;
        margin-bottom: 24px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        font-size: 2rem;
    }
`;

export const TextBox = styled.div`
    max-width: 680px;
    width: 100%;
    padding-right: 64px;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        padding-right: 0;
        max-width: 100%;
    }
`;

export const Text = styled(Paragraph)`
    color: #000;
`;

export const TechnologyWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: 500px;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_big}) {
        //max-width: 416px;
    }
    
    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        max-width: 386px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop_small}) {
        max-width: 334px;
    }

    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet_big}) {
        max-width: 286px;
    }


    @media screen and (max-width: ${({theme}) => theme.breakpoints.tablet}) {
        margin-top: 48px;
        justify-content: center;
    }
`;

export const TechnologyItemWrapper = styled.div`
    width: 25%;
    display: flex;
    justify-content: flex-end;

`

export const TechnologyItem = styled.div`
    padding: 20px;
    width: 80px;
    height: 80px;
    border-radius: 15px;
    box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.565);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;

    @media screen and (max-width: ${({theme}) => theme.breakpoints.laptop}) {
        width: 60px;
        height: 60px;
        margin-bottom: 18px;
        padding: 16px;
    }
`;

export const Icon = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

export const IconTitle = styled.div``;
